<main
    #modalContainer
    id="modal-container"
    class="flex flex-col items-center bg-white overflow-y-auto h-screen md:h-fit max-h-screen md:rounded-3xl w-screen md:w-[400px] relative"
    (scroll)="onScroll($event)"
>
    <header class="sticky top-0 z-10 flex flex-col items-center w-full gap-3 p-4 mb-6 bg-white border-b boder-neutral-700">
        <app-icon [name]="iconName()" [class]="iconColor()" />
        <h1 class="text-xl font-semibold">{{ dialogData.title }}</h1>
    </header>

    @if (dialogData.data) {
        <div class="flex flex-col w-full gap-3 px-4 py-3 mb-6 border-b border-gray-200">
            @for (data of dialogData.data; track $index) {
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">{{ data.key }}</span>
                    <span [ngClass]="{ 'line-clamp-1': data.lineClamp }" class="text-sm">{{ data.value }}</span>
                </div>
            }
        </div>
    }

    @if (dialogData.inputs) {
        <form [formGroup]="form!" class="flex flex-col w-full gap-3 px-4 mb-6">
            @for (input of dialogData.inputs; track $index) {
                @if (input.type !== 'textarea') {
                    <!-- <app-input
                        [formControlName]="input.key"
                        class="w-full"
                        [label]="input.label"
                        [type]="input.type"
                        [placeholder]="input.placeholder ?? ''"
                        [value]="input.defaultValue"
                    /> -->
                } @else {
                    <app-textarea
                        [formControlName]="input.key"
                        class="w-full"
                        [label]="input.label"
                        [placeholder]="input.placeholder ?? ''"
                        [value]="input.defaultValue"
                    />
                }
            }
        </form>
    }

    @if (dialogData.content) {
        <section class="flex items-center justify-center w-full basis-full grow-0 md:basis-0">
            @if (!dialogData.markdown) {
                <div class="flex flex-col max-h-full gap-6 px-4 text-center text-gray-600 text-pretty">
                    <p class="whitespace-pre-line">{{ dialogData.content }}</p>
                    @if (dialogData.checkbox) {
                        <div
                            [ngClass]="checkBox() ? 'bg-primary-50' : 'bg-white'"
                            class="flex items-center gap-3 px-3 py-2 border border-gray-100 rounded-xl"
                        >
                            <app-checkbox [border]="true" [(value)]="checkBox"></app-checkbox>
                            <p
                                [ngClass]="checkBox() ? 'text-primary' : 'text-gray-400'"
                                class="inline-block text-sm font-medium whitespace-nowrap"
                            >
                                {{ dialogData.checkbox?.label }}
                            </p>
                        </div>
                    }
                </div>
            } @else {
                <div class="flex flex-col gap-6">
                    <markdown class="w-full px-4 text-sm text-center text-gray-700 basis-full grow-0" [data]="dialogData.content" />
                    @if (dialogData.checkbox) {
                        <div
                            [ngClass]="checkBox() ? 'bg-primary-50' : 'bg-white'"
                            class="flex items-center gap-3 px-3 py-2 border border-gray-100 rounded-xl"
                        >
                            <app-checkbox [(value)]="checkBox"></app-checkbox>
                            <p
                                [ngClass]="checkBox() ? 'text-primary' : 'text-gray-400'"
                                class="inline-block text-sm font-medium whitespace-nowrap"
                            >
                                {{ dialogData.checkbox?.label }}
                            </p>
                        </div>
                    }
                </div>
            }
        </section>
    }
    <footer class="sticky bottom-0 z-10 flex w-full gap-3 p-4 mt-6 bg-white">
        @if (!dialogData.buttons?.cancel?.hidden) {
            <app-button
                class="flex-1"
                expand
                [variant]="dialogData.buttons?.cancel?.variant ?? 'outline'"
                [color]="dialogData.buttons?.cancel?.color ?? 'gray'"
                (click)="onCancel()"
                rounded="lg"
                >{{ dialogData.buttons?.cancel?.text ?? '취소' }}</app-button
            >
        }
        @if (!dialogData.buttons?.confirm?.hidden) {
            <app-button
                class="flex-1"
                expand
                [color]="dialogData.buttons?.confirm?.color ?? 'primary'"
                [variant]="dialogData.buttons?.confirm?.variant ?? 'solid'"
                (click)="onConfirm()"
                [disabled]="dialogData.checkbox ? (!!form && form.invalid) || !checkBox() : !!form && form.invalid"
                rounded="lg"
                >{{ dialogData.buttons?.confirm?.text ?? '확인' }}</app-button
            >
        }
    </footer>
</main>
